import { useField } from 'formik'
import styles from './inputs.module.scss'

const CustomCheckbox = ({ label, value, size, ...props }) => {
  const [field, meta] = useField({ ...props, type: 'checkbox', value })
  const checkboxId = props.id || `${props.name}-${value}`
  const isChecked = Array.isArray(meta.value)
    ? meta.value.includes(value)
    : false
  return (
    <div className={styles.checkbox}>
      <label
        className={
          size === 'lg' ? styles.checkboxLabelLg : styles.checkboxLabel
        }
        htmlFor={checkboxId}
      >
        <input
          type="checkbox"
          {...field}
          {...props}
          className={
            size === 'lg' ? styles.checkboxSizeLg : styles.checkboxSize
          }
          // checked={meta.value.includes(value)}
          checked={isChecked}
          id={checkboxId}
        />
        {label}
      </label>
      {meta.touched && meta.error && (
        <div className={styles.error}>{meta.error}</div>
      )}
    </div>
  )
}

export default CustomCheckbox
